import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { BaseComponent } from 'src/app/core/base.component';
import { OutingService } from 'src/app/outing/outing.service';
import { QueryFilter } from 'src/app/shared/models/query-filter.model';
import { SessionService } from 'src/app/shared/services/session.service';
import { OutingIterationQueryFilter } from '../models/outing-iteration-query-filter';
import { OutingIterationList } from '../models/outing-iteration.list';
import { OutingList } from '../models/outing.list';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { OutingEditModalComponent } from '../outing-edit-modal/outing-edit-modal.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-outings-list',
    templateUrl: './outings-list.component.html',
    styleUrls: ['./outings-list.component.scss'],
    standalone: false
})
export class OutingsListComponent extends BaseComponent implements OnInit {
  @Input() filter: QueryFilter = new QueryFilter();
  public iterationFilter: OutingIterationQueryFilter = new OutingIterationQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public outings: OutingList[] = [];
  public outingIterations: OutingIterationList[] = [];
  public iterationDisplayedColumns: string[] = ['courseName', 'startDate', 'cost', 'edit']
  public expandedOuting: OutingList | null;

  constructor(public sessionService: SessionService,
    private router: Router,
    private outingService: OutingService,
    public dialog: MatDialog,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.displayedColumns = ['name', 'actions']
  }

  ngOnInit(): void {
    this.getAllOutingsByUserId();
  }

  getAllOutingsByUserId() {
    this.isLoading = true;
    this.outingService.getOutingsByOrganization(this.sessionService.getUser().organizationId, this.filter).subscribe(results => {
      this.outings = results.results;
      this.filter.totalCount = results.totalCount;
      this.updateFilterEvent.emit(results.results);
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    });
  }

  getOutingIterations(outing: OutingList): any {
    this.expandedOuting = this.expandedOuting === outing ? null : outing;
    this.iterationFilter.outingId = outing.id;
    this.iterationFilter.isSubset = true;
    this.outingService.getOutingIterationsByOutingId(outing.id, this.iterationFilter).subscribe(results => {
      if (results.totalCount > 0) {
        this.outingIterations = results.results;
      } else {
        this.outingIterations = [];
      }
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 10;
  }

  deleteOuting(outing: OutingList) {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      width: '40vw'
    });

    dialogRef.componentInstance.title = 'Delete Outing';
    dialogRef.componentInstance.body = `Are you sure you want to delete the outing <strong>${outing.name}</strong>? <br /><br />
    You will no longer be able to access any of the Iterations associated to this outing as they will be deleted as well.`

    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
  }

  editOuting(outing: OutingList) {
    const dialogRef = this.dialog.open(OutingEditModalComponent, {
      width: '40vw'
    });

    dialogRef.componentInstance.outing = outing;

    dialogRef.afterClosed().subscribe(() => {
      this.getAllOutingsByUserId();
    });
  }
}
